export const cache = {
  store: {} as { [key: string]: any },
  async get<T>(
    key: string,
    factory: () => Promise<T>,
    { cache = true }: { cache?: boolean } = {},
  ): Promise<T> {
    if (cache && this.store[key]) {
      return this.store[key];
    }

    this.store[key] = factory().catch((error) => {
      delete this.store[key];

      throw error;
    });

    return this.store[key];
  },
};
